import * as THREE from 'three'
const OrbitControls = require('three-orbit-controls')(THREE)
const { WebGLRenderer, Scene, Color, PerspectiveCamera, DirectionalLight, AmbientLight } = THREE

const defaultOptions = {
  width: 375,
  height: 375
}

export default class Stage3D {
  constructor (el, options) {
    this.container = typeof el === 'string' ? document.getElementById(el) : el
    this.options = Object.assign({}, defaultOptions, options)

    this.renderer = null
    this.scene = null
    this.camera = null

    this.init()
  }

  init () {
    this.createRenderer()
    this.createScene()
    this.createCamera()
    this.createController()
    this.createLight()
    this.loop()
    this.onInitialized()
  }

  onInitialized () {}

  createRenderer () {
    const { width, height } = this.options
    const renderer = new WebGLRenderer({
      alpha: true,
      antialias: true,
      preserveDrawingBuffer: true
    })

    renderer.setClearColor(0x000000, 0)
    renderer.setSize(width * 2, height * 2)
    renderer.domElement.style.position = 'relative'
    renderer.domElement.style.width = `${width}px`
    renderer.domElement.style.height = `${height}px`

    this.container.appendChild(renderer.domElement)
    this.renderer = renderer
  }

  createScene () {
    this.scene = new Scene()
    this.scene.background = new Color(0xe8e8e8)
  }

  createCamera () {
    const { width, height } = this.options
    const camera = new PerspectiveCamera(40, width / height, .1, 1000)
    camera.position.set(0, 0, 20)
    this.scene.add(camera)
    this.camera = camera
  }

  createController () {
    const controller = new OrbitControls(this.camera, this.container)
    controller.rotateSpeed = 0.8
    controller.autoRotate = false
    controller.autoRotateSpeed = 2
    controller.enableDamping = true
    controller.enableZoom = false
    controller.enablePan = false
    controller.enabled = true
    this.controller = controller
  }

  createLight () {
    const l1 = new DirectionalLight(0x17c4ff)
    l1.position.set(0, 0, -10)
    this.camera.add(l1)
    
    const l2 = new DirectionalLight(0x17c4ff)
    l2.position.set(10, 10, 5)
    this.camera.add(l2)
		
		const l3 = new AmbientLight(0x000000)
    this.scene.add(l3)
  }

  loop = () => {
    requestAnimationFrame(this.loop)
    this.render()
    this.controller.update()
  }

  render () {
    this.renderer.render(this.scene, this.camera)
  }
}


// WEBPACK FOOTER //
// ./src/utils/stage-3d.js